export default "__VITE_ASSET__5baa5d18__"